import { useEffect, useState } from 'react';
import { api } from '../lib/api.ts';
import { toast } from '../lib/toast.tsx';

export function ContactPage() {
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [website, setWebsite] = useState(''); // 허니팟 — 사람은 안 채움
  const [token, setToken] = useState('');
  const [busy, setBusy] = useState(false);

  // 폼 로드 시 봇 방지 챌린지 토큰 발급.
  const loadToken = () => {
    api
      .contactChallenge()
      .then((r) => setToken(r.token))
      .catch(() => setToken(''));
  };
  useEffect(loadToken, []);

  const canSubmit = subject.trim().length > 0 && message.trim().length > 0 && !busy;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;
    setBusy(true);
    try {
      let t = token;
      if (!t) t = (await api.contactChallenge()).token;
      await api.contact({
        email: email.trim() || undefined,
        subject: subject.trim(),
        message: message.trim(),
        token: t,
        website,
      });
      toast.success('문의가 전송되었어요. 빠르게 회신할게요.');
      setSubject('');
      setMessage('');
    } catch (err) {
      toast.error(`전송 실패: ${(err as Error).message}`);
    } finally {
      setBusy(false);
      loadToken(); // 토큰 단일 사용 → 다음 제출용 새 토큰
    }
  };

  return (
    <main className="nf-page" style={{ padding: '120px 24px 80px', maxWidth: 560, margin: '0 auto' }}>
      <h1 style={{ fontSize: 30, fontWeight: 900, letterSpacing: '-.02em', margin: '0 0 8px' }}>문의하기</h1>
      <p style={{ fontSize: 14, color: 'var(--fg-soft)', lineHeight: 1.7, margin: '0 0 28px' }}>
        서비스 제안, 오류 제보, 제휴 등 무엇이든 보내주세요. 회신받을 이메일을 남기면 답변드려요.
      </p>

      <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {/* 허니팟: 화면 밖 숨김. 봇이 채우면 서버가 드롭. */}
        <input
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 }}
        />

        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ fontSize: 12, color: 'var(--fg-muted)', fontWeight: 600 }}>회신받을 이메일 (선택)</span>
          <input
            type="email"
            className="nf-modal-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            disabled={busy}
            maxLength={200}
          />
        </label>

        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ fontSize: 12, color: 'var(--fg-muted)', fontWeight: 600 }}>제목</span>
          <input
            type="text"
            className="nf-modal-input"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="문의 제목"
            disabled={busy}
            maxLength={200}
            required
          />
        </label>

        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ fontSize: 12, color: 'var(--fg-muted)', fontWeight: 600 }}>내용</span>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="내용을 입력하세요"
            disabled={busy}
            maxLength={5000}
            required
            rows={8}
            style={{
              width: '100%',
              background: 'rgba(20,20,26,.7)',
              border: '1px solid var(--line)',
              borderRadius: 8,
              padding: 12,
              color: 'var(--fg)',
              fontSize: 14,
              fontFamily: 'inherit',
              lineHeight: 1.6,
              resize: 'vertical',
              outline: 'none',
            }}
          />
        </label>

        <button
          type="submit"
          className="nf-btn primary"
          disabled={!canSubmit}
          style={{ height: 46, fontSize: 15, opacity: canSubmit ? 1 : 0.5 }}
        >
          {busy ? '전송 중…' : '보내기'}
        </button>
      </form>
    </main>
  );
}
